import { FiX } from 'react-icons/fi'
import CircleButton from 'components/CircleButton'
import React from 'react'
import { StyledCameraDisplayControlsContainer } from 'components/Selfiebooth/CameraDisplay/styled'
import { IoIosCamera } from 'react-icons/io'

import { MdFlipCameraAndroid } from 'react-icons/md'
import { isMobile } from 'utils/index'

interface ControlsProps {
  stopCamera: () => void;
  capturePhoto: () => void;
  switchCamera: () => void;
}

const Controls = ({ stopCamera, capturePhoto, switchCamera }: ControlsProps) => {
  return <>
    <StyledCameraDisplayControlsContainer>
      <CircleButton
        icon={<FiX />}
        label="Close camera"
        onClick={stopCamera}
        type="close"
        id="stopCamera"
      />
      {isMobile && <CircleButton
        icon={<MdFlipCameraAndroid width={30} height={30} />}
        onClick={switchCamera}
        label="Switch camera"
        type="reverse"
        id="switchCamera"
      />}
      <CircleButton
        icon={<IoIosCamera />}
        onClick={capturePhoto}
        label="Take a picture"
        id="capturePhoto"
      />
    </StyledCameraDisplayControlsContainer>
  </>
}

export default Controls;